import { fn } from "util";
import CreatePresenter from "./create.presenter";
import { ProductRepository } from "core/repository";
// import _ from 'lodash';

export default class EditPresenter extends CreatePresenter {
  initialState() {
    return {
      ...super.initialState(),
      title: "Editar Produto",
      mode: "edit"
    };
  }

  async onStart() {
    const currentUser = await this.mRuntime.get("currentUser");

    if (!currentUser.company.features.includes("manage_sellable")) {
      return this.navigateTo("app.registration.product");
    }

    await super.onStart();
  }

  async loadProduct() {
    const productUuid = await this.router.stateService.params.productUuid;
    const result = await ProductRepository.getOnline(productUuid);
    const currentUser = await this.mRuntime.get("currentUser");

    if (result.success) {
      if (!result.data.taxes) {
        result.data.taxes = {};
      }

      if (result.data.taxes.use_default_configuration === undefined) {
        result.data.taxes.use_default_configuration = false;
      }

      await super.loadOptionalGroups(result.data);
      await super.loadProductVariations(result.data);
      const barcodes = await super.loadBarcodes();

      this.viewModel.optionalGroupsUuids = result.data.optional_groups_uuids;
      this.viewModel.form = result.data;
      this.viewModel.form.barcodes = barcodes;
      this.viewModel.companyFiscalInformations =
        currentUser.company.fiscal_informations;
      // super.loadSkus();
    } else {
      this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Não conseguimos carregar este produto! Tente novamente em alguns minutos."
      });
    }

    return result;
  }

  async persist() {
    const sellable = this.viewModel.form;
    const taxes = [
      "cest",
      "ncm",
      "cfop",
      "csosn",
      "pis",
      "cofins",
      "origin",
      "icms",
      "pis_normal",
      "cofins_normal"
    ];
    const crt3fields = {
      icms: [
        "cst",
        "cfop",
        "modBC",
        "pICMS",
        "pFCP",
        "modBCST",
        "pMVAST",
        "pRedBCST",
        "pICMSST",
        "pFCPST",
        "pRedBC",
        "motDesICMS",
        "pST",
        "pFCPSTRet",
        "pRedBCEfet",
        "pICMSEfet"
      ],
      pis_normal: ["cst", "pPIS", "vAliqProd"],
      cofins_normal: ["cst", "pCOFINS", "vAliqProd"]
    };

    taxes.forEach(tax => {
      if (fn.isBlank(sellable.taxes[tax]) || sellable.taxes[tax] === "none") {
        delete sellable.taxes[tax];
      } else {
        if (["icms", "pis_normal", "cofins_normal"].includes(tax)) {
          crt3fields[tax].forEach(field => {
            if (
              fn.isBlank(sellable.taxes[tax][field]) ||
              sellable.taxes[tax][field] === "none"
            ) {
              delete sellable.taxes[tax][field];
            }
          });
        }
      }
    });

    if (sellable.taxes.use_default_configuration) {
      const defaultTaxes = [
        "cfop",
        "csosn",
        "pis",
        "cofins",
        "origin",
        "icms",
        "pis_normal",
        "cofins_normal"
      ];
      defaultTaxes.forEach(tax => {
        delete sellable.taxes[tax];
      });
    }

    const optionalGroupsUuids = this.viewModel.optionalGroupsUuids;
    sellable.optional_groups_uuids = optionalGroupsUuids;

    if (sellable.type === "product_kit") {
      const stock = ["stock_count", "stock_value"];
      stock.forEach(attribute => delete sellable[attribute]);
      sellable.optional_groups_uuids = [];
    }

    /*
    const { selectedVariations } = this.viewModel;
    let deleteSkus = false;

    const variations_uuids = this.viewModel.form.variations_uuids && this.viewModel.form.variations_uuids.length ?
      this.viewModel.form.variations_uuids.slice() :
      [];
    const selectedVariationsUuids = selectedVariations.reduce((uuidAccumulator, variation) => {
      if (variation.uuid) {
        uuidAccumulator.push(variation.uuid)
      }
      return uuidAccumulator
    }, []);
    deleteSkus = !(_.isEqual(selectedVariationsUuids, variations_uuids))
    sellable.variations_uuids = selectedVariationsUuids;
    */

    const isValid = this.doValidateForm();

    if (isValid) {
      this.postPersist(
        await ProductRepository.update(sellable.uuid, sellable),
        sellable /* deleteSkus */
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/edit.presenter.js